// extracted by css-extract-rspack-plugin
export default {"container":"container-q8dZ1R","header":"header-VHbhWZ","tabsDivider":"tabsDivider-rnNUMz","tabs":"tabs-lnhWR2"};